import * as primaryTheme from "../../assets/styles/primary.module.scss"
let defaultTheme = {};
if (primaryTheme && primaryTheme['primaryColor']) {
  for (let key in primaryTheme) {
    let index = primaryTheme[key].indexOf(",");
    let value = primaryTheme[key].substring(
      index + 1,
      primaryTheme[key].length - 1
    );
    let new_key = key;
    if (key && key.indexOf("_") !== -1) {
      new_key = key.replaceAll("_", "-");
    }
    defaultTheme[new_key] = value.replace(" ", "");
  }
}
export const themes = {
  //极致蓝色
  custom1961A8: {
    ...defaultTheme,
    ...{
      primaryColor: `#1961A8`,
    },
  },
  //品质黑色
  custom0D253D: {
    ...defaultTheme,
    ...{
      primaryColor: `#0D253D`,
      "primary-hover-color": "#DCE1E8",
      "menu-hover-color": "#F0F2F3",
      "switch-border": "#DCE1E8",
      "switch-background": "#E9EDF4",
      "tabs-card-bag": "#EFF1F2",
      "custom-btn-bg-color":"#E4E8EE"
    },
  },
  //活力绿色
  custom16A085: {
    ...defaultTheme,
    ...{
      primaryColor: `#16A085`,
      "primary-hover-color": "#D0EAE6",
      "menu-hover-color": "#E8F6F3",
      "switch-border": "#D0EAE6",
      "switch-background": "#DFF7F4",
      "tabs-card-bag": "#E6F6F3",
      "custom-btn-bg-color":"#E0F5F2",
    },
  },
  //天空蓝色
  custom1996E0: {
    ...defaultTheme,
    ...{
      primaryColor: `#1996E0`,
      "primary-hover-color": "#D3EBF9",
      "switch-border": "#D3EBF9",
      "switch-background": "#E6F4FC",
      "tabs-card-bag": "#E9F7FF",
      "custom-btn-bg-color":" #DEF3FF",
    },
  },
};
